"use client";

// 404 page uses client components
export const dynamic = 'force-dynamic';

import Link from 'next/link';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { t } from '@/lib/i18n';


export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* 404 Number */}
        <div className="space-y-4">
          <h1 className="text-8xl sm:text-9xl font-bold text-blue-600 tracking-tight">
            404
          </h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        {/* Error Message */}
        <div className="space-y-4">
          <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900">
            {t('not_found.title')}
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            {t('not_found.description')}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4 pt-6">
          <Link
            href="/"
            className="inline-flex items-center justify-center w-full px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
          >
            <Home className="w-5 h-5 mr-2" />
            {t('not_found.go_to_homepage')}
          </Link>
          
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center flex-1 px-4 py-2 border border-blue-300 text-blue-700 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded-lg transition-colors duration-200"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              {t('not_found.go_back')}
            </button>
            
            <Link
              href="/dashboard"
              className="inline-flex items-center justify-center flex-1 px-4 py-2 border border-blue-300 text-blue-700 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded-lg transition-colors duration-200"
            >
              <Search className="w-4 h-4 mr-2" />
              {t('not_found.dashboard')}
            </Link>
          </div>
        </div>

        {/* Help Text */}
        <div className="pt-8 border-t border-blue-200">
          <p className="text-sm text-gray-500">
            {t('not_found.help_text')}{' '}
            <Link href="/help" className="text-blue-600 hover:text-blue-700 underline">
              {t('not_found.help_center')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
} 
